import { render, staticRenderFns } from "./PluginsListTraining.vue?vue&type=template&id=e93a1fa2"
import script from "./PluginsListTraining.vue?vue&type=script&lang=js"
export * from "./PluginsListTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports